import React from 'react';
import { Book, CheckCircle2, Gift } from 'lucide-react';
export function TomosGrid() {
  const tomos = [{
    id: 1,
    level: 'Nivel Inicial',
    weeks: 'Semanas 1 a 10',
    desc: 'La base de todo. Patrones de movimiento, técnica fundamental y adaptación anatómica. El primer contacto del alumno con el funcional real.'
  }, {
    id: 2,
    level: 'Nivel Inicial',
    weeks: 'Semanas 11 a 20',
    desc: 'Consolidación técnica. Correcciones verbales, progresión de carga y confianza en el movimiento.'
  }, {
    id: 3,
    level: 'Nivel Inicial',
    weeks: 'Semanas 21 a 30',
    desc: 'Core funcional y fuerza de base. Kettlebell, peso corporal y primeras progresiones de intensidad.'
  }, {
    id: 4,
    level: 'Nivel Inicial',
    weeks: 'Semanas 31 a 40',
    desc: 'Cierre del nivel inicial. Benchmark de salida y preparación para el salto al nivel intermedio.'
  }, {
    id: 5,
    level: 'Nivel Intermedio',
    weeks: 'Semanas 41 a 50',
    desc: 'Sobrecarga real. RPE, zonas de intensidad y potencia avanzada. Fuerza orientada con Kettlebell.'
  }, {
    id: 6,
    level: 'Nivel Intermedio',
    weeks: 'Semanas 51 a 60',
    desc: 'Fuerza máxima del nivel. Periodización ondulada diaria (DUP) y trabajo metabólico avanzado.'
  }, {
    id: 7,
    level: 'Nivel Intermedio',
    weeks: 'Semanas 61 a 70',
    desc: 'Resistencia de fuerza y circuitos de alta densidad. El punto de inflexión del alumno intermedio.'
  }, {
    id: 8,
    level: 'Nivel Intermedio',
    weeks: 'Semanas 71 a 80',
    desc: 'Benchmark intermedio avanzado. Cierre del nivel y preparación para el salto al avanzado.'
  }, {
    id: 9,
    level: 'Nivel Avanzado',
    weeks: 'Semanas 81 a 90',
    desc: 'Gestos olímpicos y movimientos de alta complejidad técnica. Potencia máxima del sistema.'
  }, {
    id: 10,
    level: 'Nivel Avanzado',
    weeks: 'Semanas 91 a 100',
    desc: 'Fuerza máxima y potencia explosiva. Protocolos de alta intensidad para el atleta avanzado.'
  }, {
    id: 11,
    level: 'Nivel Avanzado',
    weeks: 'Semanas 101 a 110',
    desc: 'Competición y rendimiento. Clases diseñadas para atletas que buscan el límite real.'
  }, {
    id: 12,
    level: 'Nivel Avanzado',
    weeks: 'Semanas 111 a 120',
    desc: 'Cierre del sistema. Benchmark final, evaluación de 120 semanas y protocolo de mantenimiento.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-242">
      <div className="text-center mb-16" data-id="element-243">
        <h2 className="text-4xl font-extrabold text-stone-900 mb-4" data-id="element-244">
          Los 12 Tomos Completos
        </h2>
        <p className="text-xl text-stone-600" data-id="element-245">
          Clases graficadas · Por nivel y objetivo · Listo para usar mañana
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-246">
        {tomos.map(tomo => <div key={tomo.id} className="bg-white rounded-2xl p-6 border border-stone-200 shadow-sm hover:border-coral-300 hover:shadow-md transition-all" data-id="element-247">
            <div className="flex items-center justify-between mb-4" data-id="element-248">
              <span className="text-coral-500 font-black text-xl" data-id="element-249">
                TOMO {tomo.id}
              </span>
              <Book className="text-stone-300 w-6 h-6" data-id="element-250" />
            </div>
            <h3 className="text-stone-900 font-bold text-lg mb-1" data-id="element-251">
              {tomo.level}
            </h3>
            <p className="text-coral-600 text-sm font-medium mb-4" data-id="element-252">
              — {tomo.weeks}
            </p>
            <p className="text-stone-600 text-sm leading-relaxed" data-id="element-253">
              {tomo.desc}
            </p>
          </div>)}
      </div>

      <div className="flex flex-wrap justify-center gap-6 text-sm md:text-base font-medium text-stone-700 bg-white py-6 rounded-2xl border border-stone-200 shadow-sm" data-id="element-254">
        <span className="flex items-center" data-id="element-255">
          <span className="mr-2" data-id="element-256">✏️</span> Ejercicios graficados en cada tomo
        </span>
        <span className="flex items-center" data-id="element-257">
          <span className="mr-2" data-id="element-258">⚡</span> Sistema "Abrí y Dictás"
        </span>
        <span className="flex items-center" data-id="element-259">
          <span className="mr-2" data-id="element-260">📋</span> Fichas listas para imprimir
        </span>
        <span className="flex items-center" data-id="element-261">
          <span className="mr-2" data-id="element-262">🇦🇷</span> Contenido 100% adaptado a Argentina
        </span>
      </div>
    </section>;
}
export function BonusesGrid() {
  const bonuses = [{
    id: 1,
    icon: '🛡️',
    title: 'Protocolo Pre-Hab: Cero Lesiones',
    desc: 'Rutinas de movilidad y activación para prevenir lesiones de hombro, rodilla y columna en tus alumnos. El protocolo que te protege a vos y a tu clase.',
    bg: 'bg-sky-700',
    spine: 'bg-sky-900'
  }, {
    id: 2,
    icon: '🍗',
    title: 'Nutrición de Campo: El Profe a Fuego',
    desc: 'Guía práctica para asesorar a tus alumnos sobre nutrición sin ser nutricionista. Lo que funciona de verdad en el campo.',
    bg: 'bg-coral-500',
    spine: 'bg-coral-700'
  }, {
    id: 3,
    icon: '💊',
    title: 'Guía de Suplementación Inteligente',
    desc: 'Qué recomendar, qué evitar y cómo responder las preguntas de tus alumnos con fundamento real.',
    bg: 'bg-violet-700',
    spine: 'bg-violet-900'
  }, {
    id: 4,
    icon: '⚡',
    title: 'El WOD del Profe: Entrenar en 30 Minutos',
    desc: 'Sesiones de alta intensidad diseñadas para el profe que no tiene tiempo. Porque si vos no entrenás, tu autoridad se va al piso.',
    bg: 'bg-amber-600',
    spine: 'bg-amber-800'
  }, {
    id: 5,
    icon: '🧠',
    title: 'Mentalidad de Coach-Atleta',
    desc: 'Herramientas de liderazgo, manejo de grupos difíciles y cómo construir una comunidad que no se va a otro gimnasio.',
    bg: 'bg-slate-800',
    spine: 'bg-slate-950'
  }, {
    id: 6,
    icon: '👁️',
    title: 'Anatomía Visual: El Ojo Clínico del Profe',
    desc: 'Guía visual para detectar errores técnicos en 3 segundos. Los 6 movimientos base del funcional con sus errores más comunes y cómo corregirlos al instante.',
    bg: 'bg-emerald-700',
    spine: 'bg-emerald-900'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-stone-50 border-y border-stone-200" data-id="element-263">
      <div className="max-w-7xl mx-auto" data-id="element-264">
        <div className="text-center mb-12" data-id="element-265">
          <h2 className="text-4xl md:text-5xl font-extrabold text-stone-900 mb-4" data-id="element-266">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-lg md:text-xl text-stone-600 mb-8" data-id="element-267">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <div className="inline-flex items-center justify-center bg-coral-500 text-white font-bold text-base md:text-lg px-8 py-4 rounded-full shadow-lg shadow-coral-500/20" data-id="element-268">
            <Gift className="w-5 h-5 mr-2" data-id="element-269" />
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-270">
          {bonuses.map(bonus => <div key={bonus.id} className="bg-white rounded-3xl p-6 md:p-8 border border-stone-200 shadow-sm hover:shadow-md transition-shadow flex flex-col items-center text-center" data-id="element-271">
              {/* Book cover mockup */}
              <div className="relative mb-6 mt-2 transform hover:scale-105 transition-transform duration-300" data-id="element-272">
                <div className={`relative ${bonus.bg} rounded-xl w-44 h-60 shadow-xl overflow-hidden flex flex-col justify-between p-5`} data-id="element-273">
                  {/* Book spine effect */}
                  <div className={`absolute left-0 top-0 bottom-0 w-3 ${bonus.spine}`} data-id="element-274" />
                  <div className="absolute left-3 top-0 bottom-0 w-px bg-white/20" data-id="element-275" />

                  {/* Icon at top */}
                  <div className="text-4xl ml-2" data-id="element-276">{bonus.icon}</div>

                  {/* Bonus N */}
                  <div className="ml-2" data-id="element-277">
                    <p className="text-white font-extrabold text-2xl leading-tight" data-id="element-278">
                      Bonus {bonus.id}
                    </p>
                  </div>

                  {/* Separator + brand */}
                  <div className="ml-2" data-id="element-279">
                    <div className="h-px bg-white/30 mb-3" data-id="element-280" />
                    <p className="text-white/80 font-bold text-[10px] tracking-widest uppercase" data-id="element-281">
                      Funcional 360™
                    </p>
                  </div>
                </div>
              </div>

              {/* GRATIS pill */}
              <div className="inline-flex items-center bg-emerald-50 text-emerald-700 font-bold text-xs px-4 py-1.5 rounded-full mb-4 border border-emerald-100" data-id="element-282">
                GRATIS
              </div>

              {/* Title */}
              <h3 className="text-lg md:text-xl font-extrabold text-stone-900 mb-3 leading-snug" data-id="element-283">
                <span className="mr-1" data-id="element-284">{bonus.icon}</span>
                Bonus {bonus.id} — {titleWithoutPrefix(bonus.title)}
              </h3>

              {/* Description */}
              <p className="text-stone-600 text-sm md:text-base leading-relaxed" data-id="element-285">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}
function titleWithoutPrefix(title: string) {
  return title.split('—')[1]?.trim() || title;
}